import React, { PureComponent } from "react";
import orderBy from "lodash/orderBy";
import findIndex from "lodash/findIndex";
import cx from "classnames";

import FieldContainer from "../components/FieldContainer";
import { hasOriginalData } from "../utils";
import "./radio-field.scss";

function orderTagValues(values, options) {
  return orderBy(values, (v) => findIndex(options, (opt) => opt.value === v));
}

class MultiRadioField extends PureComponent {
  getValues = () => {
    return JSON.parse(this.props.value || "[]");
  };

  handleChange = (value) => {
    const { name, onChange, maxCount } = this.props;

    let values = this.getValues();
    if (values.indexOf(value) !== -1) {
      // Remove
      values = values.filter((v) => v !== value);
    } else {
      // Add
      values.push(value);
    }
    if (maxCount && values.length > maxCount) {
      return; // Block editing
    }

    // Order values in the same order as options
    values = orderTagValues(values, this.props.options);

    onChange(name, values.length === 0 ? undefined : JSON.stringify(values));
  };

  render() {
    const { name, value, options, vertical, required = false, disabled, locked } = this.props;
    const values = this.getValues();
    const isLocked = locked && hasOriginalData(name);
    return (
      <FieldContainer {...this.props} vertical={vertical} as="div">
        <div style={{ display: vertical ? "block" : "flex", position: "relative" }}>
          <input
            name={name}
            required={required}
            value={value || ""}
            style={{ position: "absolute", opacity: 0, width: "100%", height: 0 }}
          />
          {options.map((option, idx) => {
            const { value: radioValue, label } = option;
            const checked = values.indexOf(radioValue) !== -1;
            return (
              <label
                key={idx}
                style={{
                  display: vertical ? "block" : "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  justifyContent: "center",
                  marginRight: 20,
                }}
              >
                <input
                  className="af-checkbox-field"
                  type="checkbox"
                  value={radioValue}
                  checked={checked}
                  disabled={disabled}
                  readOnly={disabled || isLocked}
                  onChange={disabled || isLocked ? undefined : () => this.handleChange(radioValue)}
                />
                <span>{label}</span>
              </label>
            );
          })}
        </div>
      </FieldContainer>
    );
  }
}

export default class RadioField extends PureComponent {
  render() {
    const { name, options, value, onChange, vertical, required = false, disabled, locked, allowMultiple } = this.props;
    if (allowMultiple) return <MultiRadioField {...this.props} />;
    const isLocked = locked && hasOriginalData(name);
    return (
      <FieldContainer {...this.props} vertical={vertical} as="div">
        <div style={{ display: vertical ? "block" : "flex" }}>
          {options.map((option, idx) => {
            const { value: radioValue, label } = option;
            const checked = value === radioValue;
            return (
              <label
                key={idx}
                className={cx(checked && "is-active")}
                style={{
                  display: vertical ? "block" : "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 20,
                }}
              >
                <input
                  className="af-radio-field"
                  type="radio"
                  name={name}
                  value={radioValue}
                  required={required}
                  checked={checked}
                  disabled={disabled}
                  readOnly={disabled || isLocked}
                  onChange={disabled || isLocked ? undefined : () => onChange(name, radioValue)}
                />
                <span>{label}</span>
              </label>
            );
          })}
        </div>
      </FieldContainer>
    );
  }
}
